import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import Hero from "../components/site/Hero";
import EditorialMarquee from "../components/site/EditorialMarquee";
import Manifesto from "../components/site/Manifesto";
import FabricVault from "../components/site/FabricVault";
import KurtaEdits from "../components/site/KurtaEdits";
import Accessories from "../components/site/Accessories";
import CustomStudio from "../components/site/CustomStudio";
import VisitBoutique from "../components/site/VisitBoutique";
import WhatsAppFloat from "../components/site/WhatsAppFloat";
import ProductModal from "../components/site/ProductModal";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data)).catch(() => {});
  }, []);

  const related = active
    ? products.filter((p) => p.category === active.category && p._id !== active._id).slice(0, 3)
    : [];

  return (
    <div className="bg-cream min-h-screen">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <KurtaEdits products={products} onOpen={setActive} />
        <FabricVault products={products} onOpen={setActive} />
        <Accessories products={products} onOpen={setActive} />
        <CustomStudio />
        <VisitBoutique />
      </main>
      <Footer />
      <WhatsAppFloat />
      <ProductModal
        product={active}
        related={related}
        onClose={() => setActive(null)}
        onSelectRelated={(r) => setActive(r)}
      />
    </div>
  );
}
